<template lang="pug">
section.auth__container
  h1.auth__container-title Админка авторизации (Odin)🔐
  .auth-content__wrapper
    .auth-content
      h1.auth-content__title Войдите через аккаунт на сайте
      p.auth-content__subtitle Вы сможете продолжить, если Вы модератор или администратор в Odin
      the-authorization-social-link-list(
        :windowOpen="windowOpen"
      )
      p.auth-content__user-agreement Авторизуясь, вы соглашаетесь с условиями
        a(
          href="https://lifehacker.ru/terms/"
          v-text="' пользовательского соглашения'"
          target="'_blank1'"
        )
        span(
          v-text="' и '"
        )
        a(
          href="https://lifehacker.ru/privacy/"
          target="'_blank2'"
        ) политикой обработки персональных данных
      p.auth__footnote
        | * Запрещённая соцсеть корпорации Meta,
        | которая признана в России экстремистской организацией
</template>

<script>
import TheAuthorizationSocialLinkList from './TheAuthorizationSocialLinkList.vue';
import config from '../config';
import { getAccessToken } from '../utils/tokens';
import { LOGIN } from '../constants';

const { cookieName } = config;

export default {
  name: 'TheAuthorization',

  components: {
    TheAuthorizationSocialLinkList,
  },

  created() {
    this.onMessage();
    // todo: закомментировать для показа авторизации локально
    setTimeout(this.checkIsAlreadyAuthenticated, 500);
  },

  methods: {
    getAuthLink(slug) {
      // return config.baseURL + slug
      return config.baseLhUrl + slug;
    },

    windowOpen(socialNetworkName) {
      const slug = `/id/auth/${socialNetworkName}?x-auth-app=odin`;
      window.open(this.getAuthLink(slug));
    },

    login(accessToken) {
      if (accessToken) {
        return this.$store.dispatch(
          LOGIN, { token: accessToken },
        );
      }
      return this.$router.push({ name: 'Auth' });
    },

    onMessage() {
      window.addEventListener('message', (e) => {
        if (e.data && typeof e.data === 'string') {
          const data = JSON.parse(e.data);
          if (data.type === 'isAccessTokenSet') {
            this.login(data.accessToken);
          }
        }
      }, false);
    },

    checkIsAlreadyAuthenticated() {
      const accessToken = getAccessToken(cookieName);

      if (accessToken) {
        return this.$router.push('/projects');
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .auth__container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @include mobile {
      align-items: flex-start;
    }

    &-title{
      margin-bottom: 24px;
      font-size: calc(max(1.5rem, 2vw));
      color: black;
      font-weight: bold;
    }
  }


  .auth-content__wrapper {
    width: 700px;
    height: 300px;
    border-radius: 5px;
    border: solid 1px #e9e9e9;
    background-color: #ffffff;
    margin-left: 16px;
    margin-right: 16px;

    @include mobile {
      min-width: 320px;
      width: 100%;
      height: auto;
      border-radius: 5px;
      box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      margin-left: 0;
      margin-right: 0;
    }
  }

  .auth-content {
    display: flex;
    flex-direction: column;
    padding: 40px 37px 30px 37px;
    align-items: center;
    justify-content: space-between;
    min-width: 700px;
    min-height: 300px;

    @include mobile {
      min-width: 100%;
      min-height: 100%;
      justify-content: flex-start;
      padding-top: 38px;
      padding-bottom: 60px;
    }
  }

  .auth-content__title {
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    color: #000000;
    text-overflow: ellipsis;
    overflow: hidden;

    @include mobile {
      width: 100%;
      font-size: 18px;
      line-height: 1.33;
      text-align: center;
      margin-bottom: 10px;
    }
  }

  .auth-content__subtitle {
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: center;
    color: #4c4c4c;
    text-overflow: ellipsis;
    overflow: hidden;


    @include mobile {
      width: 100%;
      font-size: 12px;
      line-height: 1.5;

      margin-bottom: 18px;
    }
  }
  .auth__footnote {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #5c5c5c;
    margin-top: 24px;
    text-align: center;
  }
  .auth-content__user-agreement {
    max-width: 500px;
    text-align: center;
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.4;
    letter-spacing: normal;
    color: #4c4c4c;

    @include mobile {
      max-width: 100%;
      min-width: 300px;
      font-size: 12px;
      line-height: 1.5;
      margin-top: 21px;
    }
  }
</style>
../utils/tokens



// WEBPACK FOOTER //
// src/components/TheAuthorization.vue